import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "../../base/card/card";
import { Button } from "../../base/button/button";
import { cn } from "../../../utils";
import { StatItemList } from "./stat-item-list";
/**
 * StatListCard - A reusable card component for displaying a list of items with counts
 *
 * Used for displaying top roles, departments, or any other list with numeric values.
 * Shows an empty state when no items are available.
 */ function StatListCard({ title, items, emptyMessage, action, className, ...props }) {
    return /*#__PURE__*/ _jsxs(Card, {
        className: cn(className),
        ...props,
        children: [
            /*#__PURE__*/ _jsx(CardHeader, {
                className: "pb-3",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "flex items-center justify-between",
                    children: [
                        /*#__PURE__*/ _jsx(CardTitle, {
                            className: "text-base font-semibold",
                            children: title
                        }),
                        action && /*#__PURE__*/ _jsx(Button, {
                            variant: "link",
                            size: "small",
                            onClick: action.onClick,
                            className: "h-auto p-0",
                            children: action.label
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(CardContent, {
                children: /*#__PURE__*/ _jsx(StatItemList, {
                    items: items,
                    emptyMessage: emptyMessage
                })
            })
        ]
    });
}
export { StatListCard };

//# sourceMappingURL=stat-list-card.js.map